import { render, staticRenderFns } from "./NormalVendorCard.vue?vue&type=template&id=e039b0a8&"
import script from "./NormalVendorCard.vue?vue&type=script&lang=js&"
export * from "./NormalVendorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e039b0a8')) {
      api.createRecord('e039b0a8', component.options)
    } else {
      api.reload('e039b0a8', component.options)
    }
    module.hot.accept("./NormalVendorCard.vue?vue&type=template&id=e039b0a8&", function () {
      api.rerender('e039b0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/vendor-partners/cards/NormalVendorCard.vue"
export default component.exports